import React from "react";
import { FormControl, Typography } from "@material-ui/core";
import { Field } from "react-final-form";

import withStyles from "@material-ui/styles/withStyles";
import { styles } from "./WeekdaysSelector.styles";

import MetaError from "./MetaError";
import Weekdays from "../displays/Weekdays";

function WeekdaysSelector({ classes, id, label }) {
  return (
    <div className={classes.root}>
      <Field name={id}>
        {({ input, meta }) => (
          <div>
            <FormControl className={classes.formControl} fullWidth>
              <Typography variant="caption">{label}</Typography>
              <Weekdays edit weekdays={input.value} onChange={(val) => input.onChange && input.onChange(val)} />
            </FormControl>
            <MetaError className={classes.error} meta={meta} />
          </div>
        )}
      </Field>
    </div>
  );
}

export default withStyles(styles)(WeekdaysSelector);
